const messages = {
  step3: {
    actionBtn: "Logga in",
  },
};

export default {
  messages,
};
